import { useMemo } from "react";

import CardsResumo from "./components/CardsResumo";
import PainelItens from "./components/PainelItens";
import { custoPorTamanho } from "./lib/calculo";

/** A ficha tecnica PADRAO do sistema (cards + Ingredientes + Embalagens), com
 *  quantidade por tamanho. */
export default function FichaPorTamanho({
  sizes, porTamanho, onChange, ingredients, Combobox, getIngredientUnit, getFractionText,
  onCreateNew, mostrarCards = true, precoDe,
}) {
  const porId = useMemo(() => Object.fromEntries((ingredients || []).map((i) => [i.id, i])), [ingredients]);
  const custo = useMemo(() => custoPorTamanho(porTamanho, sizes, porId), [porTamanho, sizes, porId]);
  const preco = useMemo(() => Object.fromEntries(sizes.map((sz) => [sz.id, precoDe ? precoDe(sz) : 0])), [sizes, precoDe]);
  const comum = { sizes, porTamanho: porTamanho || {}, onChange, ingredients, porId, Combobox, getIngredientUnit, getFractionText };

  return (
    <div className="space-y-6">
      {mostrarCards && <CardsResumo sizes={sizes} custo={custo} preco={preco} />}
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <PainelItens tipo="ingredient" {...comum} onCreateNew={onCreateNew ? (nome) => onCreateNew(nome, "ingredient") : undefined} />
        <PainelItens tipo="packaging" {...comum} onCreateNew={onCreateNew ? (nome) => onCreateNew(nome, "packaging") : undefined} />
      </div>
    </div>
  );
}
